"use client";

import {useState} from "react";

const TvSquared = () => {
    const [loaded, setLoaded] = useState(false);

    if (loaded === false && typeof window !== 'undefined') {
        let _tvq = window._tvq = window._tvq || [];
        (function() {
            let session = {'user': '[customer_id]'};
            let u = (("https:" == document.location.protocol) ?
                "https://collector-7380.tvsquared.com/"
                :
                "http://collector-7380.tvsquared.com/");
            _tvq.push(['setSiteId', "TV-27631890-1"]);
            _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
            _tvq.push([function() {
                this.setCustomVariable(5, 'session', JSON.stringify(session), 'visit')
            }]);

            _tvq.push(['trackPageView']);
            let d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.defer = true;
            g.async = true;
            g.src = u + 'tv2track.js';
            s.parentNode.insertBefore(g, s);
        })();
        setLoaded(true);
    }
};

export default TvSquared;